import { Key } from '@briebug/ngrx-auto-entity';

export class EquipmentOptionType {
  @Key id: number;
  name: string;
  delta: number;
}
